import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import LinearProgress from '@material-ui/core/LinearProgress'
import BackIcon from '@material-ui/icons/ArrowBack'

import HeroLocation from '../../components/HeroLocation'
import { styles } from './styles'
import { isMobile } from '../../utils'
import { withContext } from '../../context'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../utils/hooks'

export const AccountLocation = ({
  me,
  heroConfigList,
  history: { goBack },
  context: { state }
}) => {
  const [heroConfigs, setHeroConfigs] = useState([])

  useDeepEffect(() => {
    if (!isEmpty(heroConfigList)) {
      setHeroConfigs(heroConfigList)
      console.log(heroConfigs.find((config) => config.heroType === me.heroType))
    }
  }, [heroConfigList])

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            สถานที่ของท่าน
          </Typography>
        </Toolbar>
      </AppBar>

      {state.uploading && <LinearProgress />}

      <div style={{ marginTop: 10 }}>
        <Card elevation={isMobile ? 0 : 1} square>
          <CardContent>
            {!isEmpty(heroConfigs) && (
              <HeroLocation
                hero={me}
                heroConfig={heroConfigs.find(
                  (config) => config.heroType === me.heroType
                )}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </React.Fragment>
  )
}

AccountLocation.propTypes = {
  me: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  heroConfigList: PropTypes.array.isRequired
}

export default compose(withRouter, withContext)(AccountLocation)



// WEBPACK FOOTER //
// ./src/pages/AccountLocation/index.js